<template>
  <v-select v-model="selected" :options="[{'code':'en','label':'EN'}, {'code':'ru','label':'RU'}]" :searchable="false" ></v-select>
</template>

<script>
    export default {
        name: "LanguageSwitcher",
        data () {
            const languages =
                {
                    en : 'EN',
                    ru : 'RU'
                }

            return {
                selected : {'code': this.$i18n.locale, 'label': languages[this.$i18n.locale] }
            }
        },
        watch : {
            selected : function(){
                this.$i18n.locale=this.selected.code;
                this.$cookie.set('locale', this.selected.code, { expires: 7 });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Nav/LanguageSwitcher.vue